import { useSetFlowTo, normalizePath } from 'Simple/Flow.js'
import { useClient, useMutation } from 'Data/Api.js'
import {
  notifyError,
  notifySuccess,
  useNotifications,
} from 'Logic/Notifications.js'

import query from './query.graphql.js'
import deleteMutation from './mutation-delete.graphql.js'
import copyMutation from './mutation-copy.graphql.js'

/** @type {import('Simple/types.js').useDataOnSubmit} */
export default function useDataOnSubmit(props, data) {
  let onCopy = useOnCopy(props)
  let onDelete = useOnDelete(props)

  return async function onSubmit({ value, originalValue, args, change }) {
    switch (args.type) {
      case 'copy':
        return onCopy({ value, originalValue, args, change })
      case 'delete':
        return onDelete({ value, originalValue, args, change })
      default:
        return
    }
  }
}

function useOnCopy(props) {
  let [, notify] = useNotifications()
  let client = useClient()
  let [, executeMutation] = useMutation(copyMutation)

  return async function onSubmit({ value, originalValue, args, change }) {
    let response = await client
      .query(query, { location_ids: args.location_ids })
      .toPromise()
    let objects = response.data.vaxiom_sys_organizations
      .map(organization => organization.id)
      .map(organization_id => ({
        name: value.name,
        price: value.price,
        insurance_code_id: value.insurance_code_id,
        affecting_production_report: value.affecting_production_report,
        is_included_in_insurance_claim: value.is_included_in_insurance_claim,
        organization_id,
      }))
    let mutationResponse = await executeMutation({
      objects,
    })
    if (mutationResponse.error) {
      notify(notifyError('An error has occurred while copying charges.'))
      return
    }

    notify(notifySuccess('Charge has been copied to target locations.'))
  }
}

function useOnDelete(props, data) {
  let [, notify] = useNotifications()
  let [, executeMutation] = useMutation(deleteMutation)
  let setFlowTo = useSetFlowTo(props.viewPath)

  return async function onSubmit({ value, originalValue, args, change }) {
    let mutationResponse = await executeMutation({
      id: value.id,
    })
    if (mutationResponse.error) {
      notify(notifyError(`An error has occurred while deleting charge.`))
      return
    }

    notify(notifySuccess(`Charge deleted successfully.`))

    setFlowTo(normalizePath(props.viewPath, 'ActionsAction/Delete/No'))
  }
}
